import { useEffect, useRef, useState } from 'react';
import { auth, provider, RecaptchaVerifier, signInWithPhoneNumber } from '../../firebase';
import backgroundImage from '../../img/bg_image_texture4.png'
import LogoApp from "../../img/logo.png";
import Footer from "../footer";
import { Box, Button, Divider, FormControl, FormHelperText, IconButton, TextField, Typography } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
// import { login } from '../../_services/auth/auth.service';
import { isLogin, setSelfToken } from '../../_helpers/auth/secureToken';
import { useDispatch } from "react-redux";
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { setLoader } from '../../redux';
// import { RegisterUser } from '../../_services/register';
import { sendEmailVerification, signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useFirebaseAuthentication from '../../_helpers/reusablefunctions/firebaseLoginFunctions';
import { errorLogin } from '../../_helpers/reusablefunctions/errorLogin';
import useSnackDispatcher from '../../_helpers/reusablefunctions/snackBarComponent';
import GoogleIcon from '@mui/icons-material/Google';
import GoogleImg from '../../img/google.png'
import ReusableHeader from "../../components/reusableComponents/ReusableHeader";

const textInfo = {
  fontSize: '12px',
  marginTop: '10px',
}

function PhoneAuth(props) {
  const dispatch = useDispatch();
  const { successSnack, errorSnack } = useSnackDispatcher();
  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/profile" } };
  const inputRefs = useRef([]);
  const otpLength = 6;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpCode, setOtpCode] = useState(Array(otpLength).fill(""));
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [reCAPTCHAToken, setReCAPTCHAToken] = useState(null);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [openEmailPhone, setOpenEmailPhone] = useState(true)
  const [errorEmail, setErrorEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  const [password, setPassword] = useState("");
  const [errorPass, setErrorPass] = useState(false);
  const [showPassword, setShowConfirmPass] = useState(false);
  const [showVerificationMesage, setShowVerificationMesage] = useState('');
  const[disabledBtn , setDisabledBtn]=useState(false);
  const { sendOTP, verifyOTP, loginClickHandler, registerClickHandler } = useFirebaseAuthentication({
    setConfirmationResult,
    confirmationResult,
    setReCAPTCHAToken,
    setErrorMsg,
    from: { pathname: "/profile" },
    phoneNumber,
    otpCode,
    setTimer,
    setDisabledBtn,
    setOtpCode
  });
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = (password) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);

  // ----------------phone and otp change handler ----------
  const phoneChangeHandler = (phone) => {
    setPhoneNumber(phone)
    phone.length != 12 ? setError(true) : setError(false)
  }
  const handleChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otpCode];
      newOtp[index] = value;
      setOtpCode(newOtp);
      // Move to the next input field
      if (value && index < otpLength - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  // Start Resend Timer

  useEffect(() => {
   let interval;
   if (timer > 0) {
     setIsResendDisabled(true); // disable resend button
     interval = setInterval(() => {
       setTimer((prev) => prev - 1);
     }, 1000);
   } else {
     setIsResendDisabled(false); // enable resend button
   }
 
   return () => clearInterval(interval);
 }, [timer]);

  // ------------------- Email and Password login

  const handleEmailLogin = async () => {
    if (!email) {
      setErrorEmail(true)
      setEmailMsg("Email is required.");
      return;
    } else if (!validateEmail(email)) {
      setErrorEmail(true)
      setEmailMsg("Invalid email format.");
      return;
    }
    if (!password || !validatePassword(password)) {
      setErrorPass(true)
      return;
    }

    setErrorPass(false);
    setErrorEmail(false);
    setShowVerificationMesage('')
    setEmailMsg('')
    dispatch(setLoader(true));

    try {
      const result = await signInWithEmailAndPassword(auth, email, password);

      dispatch(setLoader(false));
      if (!result.user.emailVerified) {
        setErrorEmail(true)
        setShowVerificationMesage("Please verify your email before logging in.");
        return;
      }
      setErrorEmail(false)
      setShowVerificationMesage('')
      const uid = result.user.uid;

      const loginResponse = await loginClickHandler(uid);
      if (loginResponse && loginResponse[0]) {
        setErrorEmail(true);
        setErrorPass(true);
        setShowVerificationMesage(loginResponse[0]);
        return;
      }
      console.log("Email login successful!", result);
    } catch (error) {
      dispatch(setLoader(false));
      setErrorEmail(true)
      setErrorPass(true)
      // Handle specific Firebase Auth error codes
      let errorMessage = errorLogin(error)

      setShowVerificationMesage(errorMessage);
      console.log("Error logging in with email:", error.message);
    }
  };

  // ------------- Resend verification link -------------

  const resendVerificationEmail = async () => {
    console.debug("verification link", { email, password })
    try {
      // Sign in the user temporarily to get their user object
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (!user.emailVerified) {
        await sendEmailVerification(user);
        successSnack("Verification email resent successfully. Please check your inbox.");
      } else {
        errorSnack("Your email is already verified.");
      }

      await auth.signOut(); // Logout for security reasons
    } catch (error) {
      console.error("Error resending verification email:", error.message);
      let errorMessage = errorLogin(error)

      setShowVerificationMesage(errorMessage);
    }
  };

  // -------------- google login-------------

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("User Info:", user);

      const loginResponse = await loginClickHandler(user?.uid);
      console.log('OTP verified successfully!', loginResponse);
      if (loginResponse[0]) {
        console.warn("User not found. Attempting to register...");
        try {
          await registerClickHandler(user?.uid);
          console.log("Registration successful. Logging in...");
          await loginClickHandler(user?.uid);
        } catch (registerError) {
          console.error("Registration failed:", registerError);
          setErrorMsg(errorLogin(registerError))
        }
      }

    } catch (error) {
      console.error("Google Sign-In Error:", error);
      setErrorMsg(errorLogin(error));
    }
  };


  if (isLogin()) {

    return <Redirect to={from.pathname} />;
  } else {
    return (
      <Box className="container-fluid bodyColor " style={{ height: '100vh', backgroundImage: `url(${backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
        <Box className="row">
          <ReusableHeader />

          <Box style={{ maxWidth: '600px', width: '100%', margin: 'auto' }}>
            <Box className="mt-4 mb-4 p-4 border rounded shadowCustom bg-white">
              {!openEmailPhone ? <form action="" method="" className="row g-3">
                <Box id="recaptcha-container"></Box>
                {/* {!confirmationResult ? ( */}
                {!disabledBtn ? (
                  <>
                    <h4 className="text-center mt-0">Enter Phone Number </h4>
                    <PhoneInput
                      country={'in'}
                      value={phoneNumber}
                      name="phone_number"
                      onChange={phoneChangeHandler}
                      specialLabel="Enter phone number"
                      inputStyle={{
                        width: '100%',
                      }}
                    />
                    {(error || errorMsg) && (
                      <Typography color="error" variant="caption" display="block" mt={2} gutterBottom>{errorMsg || 'Please enter valid number'}</Typography>
                    )}
                    <Typography variant='body2' sx={textInfo}>You will receive an SMS verification that may apply message and data rates.</Typography>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} >
                      <Button variant='text' onClick={() => setOpenEmailPhone(true)}
                        className='gn-actionbtn-color justify-content-start text-capitalize'>Sign In with Email</Button>
                      <Button variant="contained"
                        className={error ? '' : `gn-actionbtn px-3 ms-3`}
                        onClick={sendOTP}
                        disabled={error}>Send OTP</Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <h4 className="text-center mt-0">Enter authentication code </h4>
                    <Typography variant='body2' className='text-center'>Enter the 6-digit that we have sent via the phone number +{phoneNumber}</Typography>
                    <FormControl error={error}>
                      <Box display="flex" justifyContent="center" gap={2} mt={2}>
                        {otpCode.map((digit, index) => (
                          <TextField
                            key={index}
                            value={digit}
                            onChange={(e) => handleChange(index, e.target.value)}
                            inputRef={(ref) => (inputRefs.current[index] = ref)}
                            variant="outlined"
                            size="small"
                            inputProps={{
                              maxLength: 1,
                              style: {
                                textAlign: "center",
                                fontSize: "14px",
                                width: "20px",
                                height: "30px",
                              },
                            }}
                          />
                        ))}
                      </Box>
                      <FormHelperText>{errorMsg}</FormHelperText>
                    </FormControl>
                    <Box display={'flex'} textAlign={'center'} justifyContent={'space-between'} >
                      <Button variant='text' className="gn-actionbtn-color"
                        onClick={sendOTP}
                        disabled={isResendDisabled}>
                        Resend OTP {isResendDisabled ? `(${timer}s)` : ""}
                      </Button>
                      <Button variant="contained"
                        className='gn-actionbtn px-3 ms-3'
                        onClick={verifyOTP}
                        disabled={!otpCode.every(d => d != "") || error}>Verify OTP</Button>
                    </Box>
                    <Typography variant='body2' sx={{ ...textInfo, textAlign: 'center' }}>By continuing, you agree to our
                      <a href='https://gntunes.com/terms-condition' className='gn-actionbtn-color fw-bold text-decoration-none' target='_blank'> Terms of Service</a> and
                      <a href='https://gntunes.com/privacy' className='gn-actionbtn-color fw-bold text-decoration-none' target='_blank'> Privacy Policy</a>.</Typography>
                  </>
                )}
              </form>
                :
                <Box >
                  <form action="" method="" className="row g-3">
                    <h4 className="text-center "> Email Sign In </h4>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 0 }}>
                      <IconButton sx={{
                        width: "50px",
                        height: "50px",
                        borderRadius: " 100%",
                        color: "#fff"
                      }}
                        onClick={handleGoogleSignIn}>
                        <img src={GoogleImg} alt='google-img' className='w-100' />
                      </IconButton>
                      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', maxWidth: 300 }}>
                        <Divider sx={{ flexGrow: 1 }} />
                        <Typography sx={{ mx: 2, whiteSpace: 'nowrap' }}>or</Typography>
                        <Divider sx={{ flexGrow: 1 }} />
                      </Box>
                    </Box>
                    {showVerificationMesage && <span className='text-bg-danger fs-08 text-center m-0'>{showVerificationMesage}</span>}
                    <TextField
                      label="Email"
                      type="email"
                      value={email}
                      error={errorEmail}
                      helperText={errorEmail ? emailMsg : ''}
                      onChange={(e) => setEmail(e.target.value)}
                      fullWidth
                      margin="normal"
                      size="small"

                    />

                    <TextField
                      label="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      fullWidth
                      margin="normal"
                      size="small"
                      type={showPassword ? 'text' : 'password'}
                      error={errorPass}
                      helperText={"Password must contain at least 8 characters, including at least 1 upper case letter, 1 lower case letter,1 number and 1 special character."}
                      InputProps={{
                        endAdornment: (
                          <IconButton onClick={() => setShowConfirmPass(!showPassword)} >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        ),
                      }}
                    />
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} mt={1}>
                      <a href="/forgot-password" className="gn-actionbtn-color fw-bold text-decoration-none fs-09">
                        Forgot Password?
                      </a>
                      {/* <Typography variant="body2">
                        <span onClick={resendVerificationEmail} className="cursorPointer gn-actionbtn-color fw-bold text-decoration-none">
                          Resend Verification Link
                        </span>
                      </Typography> */}
                    </Box >
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} >
                      <Typography variant="body2">
                        <span > Create account? </span>
                        <a href="/register" className="gn-actionbtn-color fw-bold text-decoration-none">
                          Sign Up
                        </a>
                        <span> or </span>
                        <span onClick={() => setOpenEmailPhone(false)} className="cursorPointer gn-actionbtn-color fw-bold text-decoration-none">
                          Login with phone
                        </span>
                      </Typography>
                      <Button variant="contained"
                        className='gn-actionbtn px-3 ms-3'
                        onClick={handleEmailLogin} sx={{ mt: 1 }}>
                        Sign In
                      </Button>
                    </Box>
                    <Typography variant='body2' sx={{ marginTop: '20px', textAlign: 'center' }}>By continuing, you agree to our
                      <a href='https://gntunes.com/terms-condition' className='gn-actionbtn-color fw-bold text-decoration-none' target='_blank'> Terms of Service</a> and
                      <a href='https://gntunes.com/privacy' className='gn-actionbtn-color fw-bold text-decoration-none' target='_blank'> Privacy Policy</a>.</Typography>
                  </form>
                </Box >
              }
            </Box>
          </Box>
        </Box>
        <Footer />
      </Box >
    );
  }
}
export default PhoneAuth;

